var exports = {
  "i": "SecurityTab.module__warningText___REpZeT",
  "H": "SecurityTab.module__claimButton___REpZeT",
};

module.exports = exports;
